import React from 'react';
import { Card, CardContent } from './card';
import { Star, Quote, Heart } from 'lucide-react';

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Wendy M.",
      date: "March 2025",
      quote: "This place is amazing! I was nervous and within minutes was at ease. Time taken and I got exactly what I wanted - extensions and hair were thinning. Diane is lovely, explaining what she was doing. The hair is the colour I wanted, she looks at how to style to face. If you're losing hair or going thin and don't know what to do, go to this lady. Would highly recommend!",
      rating: 5,
      service: "Hair Extensions & Thinning Hair Treatment"
    },
    {
      name: "Shniece L.",
      date: "June 2025", 
      quote: "I feel reborn! Customer service was impeccable. I just want to thank Diane. I feel reborn. I can't express how grateful I am. In a time of grief and sadness as I have to bury my uncle next week, she has given me hope and faith. Thank you.",
      rating: 5,
      service: "Hair Makeover & Support"
    },
    {
      name: "Delisha B.",
      date: "June 2025",
      quote: "Amazing experience, really professional + offer sensational services! Did their absolute best to make all clients feel comfortable yet entertained too. I'm extremely satisfied with my new hairstyles + I'm also satisfied at the amount of different services they provide - they not only focus on hair but beauty + even massages, NHS referrals + much more! I would 100% recommend Need A Makeover Hair to anyone + everyone seeing as they work with all hair types, genders + ages. 💗",
      rating: 5,
      service: "Full Hair & Beauty Services"
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-5xl md:text-6xl font-bold mb-6 text-dark">
            What Our Clients Say
          </h2>
          <p className="text-xl text-subtle max-w-3xl mx-auto">
            Real reviews from satisfied clients who experienced our award-winning services
          </p>
        </div>
        
        {/* Franchise Shop Video */}
        <div className="mb-16">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-4 text-dark">See Your Future Franchise in Action</h3>
            <p className="text-lg text-subtle max-w-2xl mx-auto">
              Take a look inside our salon and see the premium services and environment your franchise will offer
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="aspect-video rounded-2xl overflow-hidden shadow-2xl border-4 border-accent-primary/20">
              <iframe
                src="https://www.youtube.com/embed/IdGcGatffHk"
                title="Need A Hair Makeover - Franchise Shop Tour & Services"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="text-center text-sm text-subtle mt-4">
              Experience the professional environment and premium services your franchise will provide
            </p>
          </div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="testimonial-card group hover:shadow-xl transition-all duration-300 h-full">
              <CardContent className="p-8 flex flex-col h-full">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                
                <Quote className="w-8 h-8 text-accent-primary/30 mb-4" />
                
                <p className="text-subtle mb-6 leading-relaxed italic flex-grow">
                  "{testimonial.quote}"
                </p>
                
                <div className="border-t pt-6 mt-auto">
                  <p className="font-semibold text-dark flex items-center">
                    {testimonial.name}
                    {testimonial.name === "Shniece L." && <Heart className="w-4 h-4 ml-2 text-red-500" />}
                  </p>
                  <p className="text-sm text-accent-primary font-medium">{testimonial.service}</p>
                  <p className="text-xs text-subtle-light mt-1">{testimonial.date}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        {/* Video Testimonial */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold mb-6 text-dark">
            See What Our Clients Are Saying
          </h3>
          <div className="max-w-2xl mx-auto">
            <div className="aspect-[9/16] max-w-sm mx-auto rounded-2xl overflow-hidden shadow-2xl border-4 border-accent-primary/20">
              <iframe
                src="https://www.youtube.com/embed/AX5Pw2vudAs"
                title="Client Video Testimonial - Need A Hair Makeover"
                className="w-full h-full"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="text-subtle mt-4 italic">
              Real client sharing their transformation experience
            </p>
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="text-center mt-12">
          <div className="bg-accent-primary/5 rounded-2xl p-8 max-w-4xl mx-auto border border-accent-primary/20">
            <h3 className="text-2xl font-bold mb-4 text-dark">Join Our Award-Winning Network</h3>
            
            {/* Franchise Business GIF */}
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_hair-opportunity/artifacts/sqwx47ux_YES%20I%20WANT%20TO%20reserve%20my%20region%20needahairmakeover.gif"
                alt="YES I WANT TO reserve my region - Need A Hair Makeover Franchise Opportunity"
                className="mx-auto rounded-2xl shadow-lg border-2 border-accent-primary/20 max-w-full h-auto"
                style={{ maxHeight: '400px' }}
              />
            </div>
            
            <p className="text-lg text-subtle mb-6">
              These are the kind of life-changing results your franchise will deliver to clients every day. 
              Be part of a business that makes a real difference in people's lives.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <span className="bg-white px-4 py-2 rounded-full text-accent-primary font-medium">⭐ 5-Star Reviews</span>
              <span className="bg-white px-4 py-2 rounded-full text-accent-primary font-medium">💝 Life-Changing Results</span>
              <span className="bg-white px-4 py-2 rounded-full text-accent-primary font-medium">🏆 Award-Winning Service</span>
              <span className="bg-white px-4 py-2 rounded-full text-accent-primary font-medium">❤️ Emotional Impact</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};